module.exports = __webpack_public_path__ + "img/arch-project-1440.a0f243a3.jpg";